export default __webpack_public_path__ + "static/media/wordpress.60bef145.jpg";